<template>

    <section class="dd-m-carousel dd-m-carousel--top-banner"
             :class="{'dd-m-hide' : !show}"
             v-if="item">
        <div>
            <div class="dd-m-carousel__slider">
                <card-quiz-offline :item="item"></card-quiz-offline>
            </div>
        </div>
    </section>

</template>
<script>

    import CardQuizOffline from "../cards/card-quiz-offline";
    export default {
        name: 'banner-quiz-offline',
        components: {CardQuizOffline},
        data: () => {
            return {
                item: null,
                show: false
            }
        },
        mounted() {
            this.getStoredBanner();
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('statusChanged', (msg, isOnline) => this.show = !isOnline);
            },
            getStoredBanner() {
                if (localStorage.banner) {
                    this.item = JSON.parse(localStorage.banner);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-quiz-offline.vue